let callback;

const setToken = (token) => {
    window.jQuery('#recaptchaToken').val(token);
};

const handle = (token) => {
	setToken(token);
	if (typeof callback === 'function') callback(token);
};


const execute = (action = 'form_submit', resultCallback = () => {}) => {
    if (!window.hasOwnProperty('grecaptcha')) {
        console.error(new Error("Google Recaptcha isn't loaded!"));
        return;
    }
    callback = resultCallback;

    const siteKey = window.iq?.recaptchaSiteKey;
    if (!siteKey) {
        console.error(new Error('Missing window.iq.recaptchaSiteKey'));
        return;
    }

    grecaptcha.enterprise.ready(() => {
        grecaptcha.enterprise
            .execute(siteKey, { action })
            .then((token) => handle(token))
            .catch((err) => console.log(err));
    });
};

const reset = () => {
	setToken('');
};


const getToken = () => {
	return window.jQuery('#recaptchaToken').val();
};

window.handleRecaptcha = handle;

module.exports = {
	execute,
    reset,
	getToken
};
